import dispatch from '../../main';
import { setDataFilters } from 'redux-modules/compare';
import { NUMBER_SELECTABLE_COUNTRY } from 'constants/compare';

function getCompareCountryDataParams(state) {
  const countryArrays = new Array(NUMBER_SELECTABLE_COUNTRY);
  const countryKeys = Object.keys(state.location.query).filter(el => el.startsWith('country'));
  const years = state.location.query.years
  ? decodeURIComponent(state.location.query.years).split(',').filter((el) => el && !isNaN(el))
  : [2017];
  if (!countryKeys.length) return { countries: [], years };

  return { countries: countryKeys.map(key => {
    const index = +key.charAt(key.length - 1);
    countryArrays[index - 1] = state.location.query[key];
    return countryArrays;
  })[0],
    years };
}

function hasNewParams(prevState, nextState) {
  return prevState.location.search !== nextState.location.search;
}

export function initCompareParams(actualState, replace, done) {
  dispatch(setDataFilters(getCompareCountryDataParams(actualState)));
  done();
}

export function updateCompareParams(prevState, nextState, replace, done) {
  if (hasNewParams(prevState, nextState)) {
    dispatch(setDataFilters(getCompareCountryDataParams(nextState)));
  }
  done();
}



// WEBPACK FOOTER //
// ./app/routes/actions/compare.js